/*
 * @Author: lizhihong lizhihong@broadptt.com
 * @Date: 2023-11-03 10:26:21
 * @LastEditors: Do not edit
 * @LastEditTime: 2025-03-17 16:23:51
 * @FilePath: \broad_dispatching_platform\src\api\beasconfig.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// const baseconfig = { //测试
//   xinextendUrlapi: 'https://apidev.xin-ptt.com:9001/pocextend',
//   apiAudioUrl: "http://apidev.xin-ptt.com/pocAudio", //测试录音文件平台
//   gpsUrlapi: "http://apidev.xin-ptt.com/pocgps", //测试定位地址
//   mmsUrlapi: "https://apidev.xin-ptt.com:9001/mms", //广播
//   videoUrlapi: "https://apidev.xin-ptt.com:9001/video", //视频
//   sosUrlapi: "https://apidev.xin-ptt.com:9001/sos-ptt03", //sos
//   regionUrlapi: "https://apidev.xin-ptt.com:9001/region", //区域群组
//   enclosureUrlapi: "https://apidev.xin-ptt.com:9001/enclosure-ptt03",                               //电子围栏
//   selfUrlapi: "http://apidev.xin-ptt.com/pocToCApi",
//   getDownPath: "https://apidev.xin-ptt.com:20008",
//   httpXin:'broaddev.xin-ptt.com:10003',
//   typeName: 'xin_poc',
//   ak: "gTV5Y1Vvppy3nUFTHQlIBvo5tVx4bqf8", //测试定位地址
//   tokenSl: { "Content-Type": "application/x-www-form-urlencoded" }
// };

const baseconfig = {  //正式
  xinextendUrlapi:'https://proxy.xinpoc.com/extend',
  apiAudioUrl: "https://proxy.xinpoc.com/audio", //测试录音文件平台
  gpsUrlapi: "https://proxy.xinpoc.com/gps", //测试定位地址
  mmsUrlapi: "https://apidev.xin-ptt.com:9001/mms", //广播
  videoUrlapi: "https://apidev.xin-ptt.com:9001/video", //视频
  sosUrlapi: "https://proxy.xinpoc.com/sos-api", //sos
  regionUrlapi: "https://apidev.xin-ptt.com:9001/region", //区域群组
  enclosureUrlapi:"https://proxy.xinpoc.com/enclosure-api",      
  selfUrlapi: "https://proxy.xinpoc.com/xintoc",                         //电子围栏
  getDownPath:"https://apidev.xin-ptt.com:20008",
  ak: "gTV5Y1Vvppy3nUFTHQlIBvo5tVx4bqf8", //测试定位地址
  tokenSl:{ "Content-Type": "application/x-www-form-urlencoded" },
  httpXin:'disp.xinpoc.com:10003',
  typeName:'xin_poc'
};

// const baseconfig = {  //美国访问正式
//   xinextendUrlapi:'https://api.global-ptt.com/extend',
//   apiAudioUrl: "https://api.global-ptt.com/audio", //测试录音文件平台
//   gpsUrlapi: "https://api.global-ptt.com/gps", //测试定位地址
//   mmsUrlapi: "https://apidev.xin-ptt.com:9001/mms", //广播
//   videoUrlapi: "https://apidev.xin-ptt.com:9001/video", //视频
//   sosUrlapi: "https://api.global-ptt.com/sos-api", //sos
//   regionUrlapi: "https://apidev.xin-ptt.com:9001/region", //区域群组
//   enclosureUrlapi:"https://apidev.xin-ptt.com:9001/enclosure",      
//   selfUrlapi: "http://xintoc.xinpoc.com:30002",                         //电子围栏
//   getDownPath:"https://apidev.xin-ptt.com:20008",
//   ak: "gTV5Y1Vvppy3nUFTHQlIBvo5tVx4bqf8", //测试定位地址
//   tokenSl:{ "Content-Type": "application/x-www-form-urlencoded" },
//   httpXin:'disp.xinpoc.com:10003',
//   typeName:'xin_poc'
// };
export default baseconfig;
